import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Payment({ result }) {
  const { strings } = useLanguage();
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (result === 'success') {
      setMessage(strings.pages.payment.successMessage);
    } else if (result === 'cancel') {
      setMessage(strings.pages.payment.cancelMessage);
    }
  }, [result, strings]);

  return (
<section className="section">
  <div className="event_hero">
    <div className="event_hero__content">
      <p className="eyebrow">
        {strings.pages.payment.eyebrow}
      </p>

      <h1 className="event_hero__title">
        {strings.pages.payment.title}
      </h1>

      <p className="event_hero__subtitle">
        {message}
      </p>
    </div>

    {/* Optional background image layer matching the event hero specification */}
    <div className="event_hero__media">
      <div className="event_hero__overlay" />
    </div>
  </div>
</section>
  );
}
